import { commonEnv } from './environment.common';

export const environment = {
  ...commonEnv,
  environmentLabel: null,
  production: true,
  version: '0.0.19',
  commitHash: '9bb54e564e1caf0552927e0b63b3d9b1efe60c9a',
  sentry: 'https://622dea0819e449c891cd503b72e2e393@o296516.ingest.sentry.io/5193397',
  zulipUrl: 'https://zulip.glb.ch',
  zulipBucketUrl:
    'https://digizeit-api.mlink.glb.ch/api/zulip/uploads?token=$UPLOAD_TOKEN&path=',
  // kronosApiUrl: 'https://digizeit-api.mlink.glb.ch',
  kronosApiUrl: 'http://localhost:5000',
  auth: {
    serverUrl: 'https://auth.cloud.triarc-labs.com/auth/',
    clientId: 'kronos',
    bearerExcludedUrls: ['http://localhost:4200'],
    scope: 'openid email profile offline_access',
    twoFaTimeLimit: 120,
    logoutUrl: 'http://localhost:4200',
  },
  salesOrder: {
    viewDiscountPreAbacus: [],
    viewDiscountPostAbacus: [],
    canEditDiscountPreAbacus: [],
    viewDiscountSpecialPreAbacus: [],
    viewDiscountSpecialPostAbacus: [],
    canEditDiscountSpecialPreAbacus: [],
  },
  showTimeDifferenceOverview: true,
  features: {
    3550: ['time', 'sales', 'purchase', 'chat'],
  },
  oneSignal: {
    'digizeit.mlink.glb.ch': {
      appId: '',
    },
    'my.glb.ch': {
      appId: '',
    },
    'my.bernaroof.ch': {
      appId: '',
    },
    'my.bauimpuls.ch': {
      appId: '',
    },
    'my.allotherm.ch': {
      appId: '',
    },
    'my.asag-asbest.ch': {
      appId: '',
    },
  },
  myAbacus: '',
  customerHub: '',
};
